export function getPricingCardClass(isFeatured: boolean): string {
  if (isFeatured) {
    return 'bg-white ring-2 ring-brand-600 shadow-soft lg:z-10'
  }

  return 'bg-white ring-1 ring-gray-200 shadow-soft'
}
